/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const.js';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';

class ParticipantGenderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: this.props.currentGender,
      reason: ''
    };
  }

  handleGenderValueChange = (event) => {
    const value = +event.target.value; // get number value for gender
    this.setState(() => ({ gender: value }));
  };

  changeReasonHandler = (event) => {
    const value = event.target.value;
    this.setState(() => ({ reason: value }));
  };

  updateParticipantGender = (e) => {
    e.preventDefault();
    const { gender, reason } = this.state;
    const { updateParticipantGender, participantId, currentGender, hide } = this.props;
    if (currentGender === gender) {
      console.log('you did not change the gender'); // should show popup with info message instead
      hide();
      return;
    }
    const payload = { gender, reason };
    updateParticipantGender(participantId, payload);
  };

  genderOptions = () => {
    let options = [];
    options.push(
      <option value="1" key={1}>
        Male
      </option>
    );
    options.push(
      <option value="2" key={2}>
        Female
      </option>
    );
    return options;
  };

  render() {
    const { isLoading, error } = this.props;
    let errorBody = '';
    if (error) {
      errorBody = (
        <Row>
          <Notification type="error" data={error} />
        </Row>
      );
    }

    return (
      <Form horizontal id="edit-participant-gender-form" onSubmit={this.updateParticipantGender}>
        <Grid id="edit-participant-gender-grid" fluid>
          {errorBody}
          <Row>
            <FormGroup controlId="participantGender">
              <ControlLabel>{consts.NEW_PARTICIPANT_GENDER_LABEL}</ControlLabel>
              <FormControl
                componentClass="select"
                onChange={this.handleGenderValueChange}
                required
                value={this.state.gender}
                disabled={isLoading}
              >
                {this.genderOptions()}
              </FormControl>
            </FormGroup>
            <FormGroup controlId="reason">
              <ControlLabel>
                {consts.CHANGE_PARTICIPANT_GENDER_REASON}
                <span> *</span>
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={this.state.reason}
                onChange={this.changeReasonHandler}
                required
                disabled={isLoading}
              />
            </FormGroup>
          </Row>
        </Grid>
        <div className="edit-modal-footer">
          <hr className="edit-modal-divider" />
          <Button
            id="edit-participant-gender-cancel-button"
            theme="default large-button"
            type="reset"
            disabled={isLoading}
            handleClick={() => {
              this.props.hide();
            }}
            label={consts.CANCEL_BTN}
          />
          <Button
            id="edit-participant-gender-save-button"
            theme="active large-button"
            type="submit"
            disabled={isLoading || this.state.reason.trim() === ''}
            label={consts.SAVE_BTN}
          >
            {isLoading ? <Loading /> : null}
          </Button>
        </div>
      </Form>
    );
  }
}

ParticipantGenderComponent.propTypes = {
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  currentGender: PropTypes.number.isRequired,
  participantId: PropTypes.number.isRequired,
  updateParticipantGender: PropTypes.func,
  hide: PropTypes.func
};

export default ParticipantGenderComponent;
